import type { Order } from './order';

// {{domain}}/api/app/orders/{{orderId}}
export const ENDPOINT = 'api/app/orders';

export type Response = Order;
